var contentful = require('contentful');
var postUtils = (function() {
    /*
        previous in server/config/,
        but "Relative imports outside of src/ are not supported.",
        and this info do not need dev, staging, pro versions,
        so put these in here
    */
    var _config = {
        "contentful": {
            "spaceID": "d3e9ax8z3s35",
            "accessToken": "f35c833533d691efd7c388f51a8ab79b4601ae004c1908a5daf25e97ae697c24",
            "newsCategoryID": "1P7uBbpV2cGC20y2Gmi8ey",
            "opinionCategoryID": "3LczueKDpSAggWU4cCyWca"
        },
        "pageSize": 20,
        "pageMaxSize": 1000 // determined by contentful, default is 100. https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters/limit
    };

    var _categorySlug2CategoryID = {
        'news-updates': _config.contentful.newsCategoryID,
        'expert-opinions': _config.contentful.opinionCategoryID
    };

    var _extractDescriptionFromPostContainer = function(postContainer){
        var pseudoSummaryText = postContainer.fields.postModules[0].fields.contentSlots[0].fields.text
            .trim()
            .replace(/&nbsp;/g, ' ')
            .replace(/\s{2,}/g, ' ')
            // simple remove markdown
            .replace(/<([A-Z]+)\b[^>]*>(.*?)<\/\1>/i, '$2')
            .replace(/<br(> ?<\/br>| ?\/>|>)/g, '')
            .replace(/#+ /g, '')
            .replace(/\[(.*?)\]\((.*?)\)/g, '$1')
            .replace(/!\[.*?\]\(.*?\)/g, '')
            .replace(/\*\*(.*?)\*\*/g, '$1')
            .replace(/_(.*?)_/g, '$1');

        // truncate
        var pseudoSummaryTruncatedText = pseudoSummaryText.split(' ').slice(0, 40).join(' ');

        // add ellipsis if needed
        if(pseudoSummaryText.length > pseudoSummaryTruncatedText.length){
            pseudoSummaryTruncatedText += '...';
        }

        return pseudoSummaryTruncatedText;
    };

    var _getPostListCacheSlug = function(categorySlug, pageNum){
        pageNum = pageNum || 1;
        return categorySlug + '/page/' + pageNum;
    };

    var _isPageNumValid = function(pageNum){
        return !isNaN(parseInt(pageNum, 10));
    };

    var _digestParams = function(params){
        var digestedParams = {
            categorySlug: params.categorySlug,
            pageNum: params.pageNum
        };

        if(params.categorySlug === 'view-all'){
            digestedParams.categorySlug = 'all';
            digestedParams.pageNum = 'view-all';
        }

        return digestedParams;
    };

    return {
        config: _config,
        categorySlug2CategoryID: _categorySlug2CategoryID,
        extractDescriptionFromPostContainer: _extractDescriptionFromPostContainer,
        contentfulClient: contentful.createClient({
            space: _config.contentful.spaceID,
            accessToken: _config.contentful.accessToken
        }),
        getPostListCacheSlug: _getPostListCacheSlug,
        isPageNumValid: _isPageNumValid,
        digestParams: _digestParams
    };

})();

module.exports = postUtils;



// WEBPACK FOOTER //
// ./src/common/modules/posts/postUtils.js